import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function BenefitsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-[#FDFBF7]" data-id="element-1">
      <Container data-id="element-2">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6" data-id="element-4">
            Why People Love SnoreStop™
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16" data-id="element-5">
          {/* Card 1 - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-10 rounded-3xl shadow-sm border border-gray-100 md:col-span-2" data-id="element-6">
            <h3 className="text-2xl font-serif text-[#1E40AF] mb-4" data-id="element-7">
              The Silence Feels Different
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-8">
              Many customers say the first thing they notice is not the
              mouthpiece. It is the quiet. The strange moment of waking up and
              realizing nobody left the room during the night.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100" data-id="element-9">
            <h3 className="text-xl font-serif text-gray-900 mb-4" data-id="element-10">
              No Machines. No Tubes. No Noise.
            </h3>
            <p className="text-gray-600 leading-relaxed mb-4" data-id="element-11">
              Unlike bulky sleep equipment, SnoreStop™ fits naturally into a
              normal bedtime routine.
            </p>
            <div className="flex gap-4 text-sm font-medium text-gray-500" data-id="element-12">
              <span data-id="element-13">Simple.</span>
              <span data-id="element-14">Comfortable.</span>
              <span data-id="element-15">Travel friendly.</span>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100" data-id="element-16">
            <h3 className="text-xl font-serif text-gray-900 mb-4" data-id="element-17">
              Comfortable Adjustable Fit
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-18">
              Designed to fit securely while remaining comfortable enough for
              nightly use.
            </p>
          </motion.div>

          {/* Card 4 - Full width */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 md:col-span-2" data-id="element-19">
            <h3 className="text-xl font-serif text-gray-900 mb-6" data-id="element-20">
              Finally Sleeping Through The Night Again
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-21">
              <div className="space-y-3 text-gray-600" data-id="element-22">
                <p data-id="element-23">Customers often describe:</p>
                <ul className="list-disc pl-5 space-y-1" data-id="element-24">
                  <li data-id="element-25">fewer interruptions</li>
                  <li data-id="element-26">calmer bedtimes</li>
                  <li data-id="element-27">quieter nights</li>
                  <li data-id="element-28">more rested mornings</li>
                </ul>
              </div>
              <div className="flex items-center" data-id="element-29">
                <p className="text-lg text-gray-800 font-medium italic border-l-2 border-blue-200 pl-4" data-id="element-30">
                  But the biggest change is emotional. The tension around sleep
                  slowly disappears.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-31">
          <Button onClick={scrollToPricing} size="lg" className="px-8" data-id="element-32">
            Finally Sleep In The Same Room Again
          </Button>
        </div>
      </Container>
    </section>;
}